import { createFeatureSelector, createReducerFactory, createSelector } from '@ngrx/store';

import { listTileReducerFactory } from '../../../pillar/dashboard/store/reducers/list-tile.reducerFactory';
import { TileState } from '../../../pillar/dashboard/store/state/TileState';
import * as actions from '../../../pillar/dashboard/store/actions/';

import { ModuleConfiguration } from '../../submission.module.config';
import { JobListModel } from '../../models/JobListModel';
import { JobModel } from '../../models/JobModel';
import { SubmittingEntityListModel } from '../../models/SubmittingEntityListModel';
import { SubmittingEntityModel } from '../../models/SubmittingEntityModel';
import { submittingEntityReducer } from './SubmittingEntity.reducer';

export interface SubmissionState {
  jobState: TileState<JobListModel, JobModel>,
  submittingEntityState: TileState<SubmittingEntityListModel, SubmittingEntityModel>
};

let stateReducer;
export function stateReducerWrapper (state = new TileState<JobListModel, JobModel>(), action: actions.Actions<any>): TileState<any, any>  {
  if(!stateReducer){
    stateReducer = listTileReducerFactory(ModuleConfiguration.moduleName, JobListModel, JobModel, new TileState<JobListModel, JobModel>());
  }
  return stateReducer(state, action);
}


export const reducers = { 
  jobState: stateReducerWrapper,
  submittingEntityState: submittingEntityReducer
};

export const getSubmissionState = createFeatureSelector(ModuleConfiguration.moduleName);

export const getJobsState = createSelector(getSubmissionState, (s: SubmissionState) => s.jobState);
export const getJobList = createSelector(getJobsState, (s: TileState<JobListModel, JobModel>) => s.list);
export const getJobListCurrentPage = createSelector(getJobsState, (s: TileState<JobListModel, JobModel>) => s.currentPage);
export const getJobListTotalCount = createSelector(getJobsState, (s: TileState<JobListModel, JobModel>) => s.totalCount);
export const getJobListLoading = createSelector(getJobsState, (s: TileState<JobListModel, JobModel>) => s.loading);
export const getJobListErrors = createSelector(getJobsState, (s: TileState<JobListModel, JobModel>) => s.errors);
export const getJobSelection = createSelector(getJobsState, (s: TileState<JobListModel, JobModel>) => s.selected);

export const getSubmittingEntityState = createSelector(getSubmissionState, (s: SubmissionState) => s.submittingEntityState);
export const getSubmittingEntityList = createSelector(getSubmittingEntityState, (s: TileState<SubmittingEntityListModel, SubmittingEntityModel>) => s.list);
export const getSubmittingEntityListTotalCount = createSelector(getSubmittingEntityState, (s: TileState<SubmittingEntityListModel, SubmittingEntityModel>) => s.totalCount);
export const getSubmittingEntityListLoading = createSelector(getSubmittingEntityState, (s: TileState<SubmittingEntityListModel, SubmittingEntityModel>) => s.loading);
export const getSubmittingEntityListErrors = createSelector(getSubmittingEntityState, (s: TileState<SubmittingEntityListModel, SubmittingEntityModel>) => s.errors);
export const getSubmittingEntitySelection = createSelector(getSubmittingEntityState, (s: TileState<SubmittingEntityListModel, SubmittingEntityModel>) => s.selected);
export const getSubmittingEntityIsReportingNotConfigured = createSelector(getSubmittingEntitySelection, (s: SubmittingEntityModel) => !s.isReportingConfigured);



// WEBPACK FOOTER //
// ./src/app/submission/store/reducers/index.ts